import { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-publicacoes.jpeg";
import { Description } from "../../components/Description";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { Modal } from "../../components/Modal";
import { mapInitialSearch, Response, Search, usePublications } from "../../hooks/usePublications";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { Submit } from "./helpers/submit";
import mock from "../../mocks/info";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

function Publications() {
  usePageTrack();

  const pathname = useLocation().pathname;
  const [results, setResult] = useState<Response|null>(null);
  const [page, setPage] = useState<number>(1);
  const [order, setOrder] = useState<string>('');
  const initialSearch = pathname?.split('/')[2];
  const firstData: Response = usePublications(initialSearch);
  const firstSearch: Search = {types: [`${mapInitialSearch(initialSearch)}`]}
  const [search, setSearch] = useState<Search|null>(initialSearch? firstSearch : null);

  const [clickedInfo, setClickedInfo] = useState(mock);
  const [isModalOpen, setIsModalOpen] = useState(false);

  async function submit(_search: Search|null, _page: number = 0, _order: string = '') {
    if(!_search) _search = search;
    if(!_page) _page = page;
    if(!_order) _order = order;
    const result = await Submit(_search, _page, _order);
    setResult(result);
    setSearch(_search);
    setPage(_page)
    setOrder(_order);
  }

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Description>
        Nesta seção você encontrará uma série de publicações selecionadas e que estão disponíveis em acesso aberto. Serão progressivamente reunidos e disponibilizados livros, capítulos de livros, pesquisas empíricas, relatórios, materiais didáticos, dentre outros.
      </Description>
      <Content>
        <Form
          initialSearch={initialSearch}
          submit={submit}
        />
        <Results
          results={results?.results || firstData.results} 
          pagination={results?.pagination || firstData?.pagination} 
          submit={submit}
          onClick={(clicked) => {
            setClickedInfo(clicked);
            setIsModalOpen(true);
          }}
        />
        <Modal isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {clickedInfo.map(info => (
          <div key={info.title} ref={info.content}>
              <span>{info.title}</span>
              <section>{info.content}</section>
            </div>
          ))}
        </Modal>
      </Content>
      <Footer />
    </>
  );
}

export default Publications;

const Content = styled(Container)`
  padding: 32px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }
`;